<template>
  <div style="display: contents;">
    <ValidationObserver ref="bookingForm" slim>
      <b-form name="BookingPaxFrm" novalidate @submit.prevent="book()">
        <b-row>
          <b-container class="content">
            <div class="printArea">
              <BusResult id="result" :result="result" :showBook="false"/>
            </div>
            <b-row>
              <b-col sm="12" class="printArea">
                <b-table-simple stacked="sm" striped caption-top  class="table table-sm border">
                  <caption class="pl-2 pl-sm-0 pb-0"><h6 class="package-title" v-translate>Passengers and room details</h6></caption>
                  <b-thead class="t-head hh-t-head">
                    <b-tr>
                      <b-td v-translate>Room</b-td>
                      <b-td></b-td>
                      <b-td v-translate>Last name*</b-td>
                      <b-td v-translate>First name*</b-td>
                      <b-td v-translate>Age</b-td>
                      <b-td v-translate>Date of birth*</b-td>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <template v-for="(p, pIndex) in pax">
                      <PaxForm
                        class="noPrint"
                        v-model="pax[pIndex]"
                        :id="'pax' + pIndex"
                        :key="'pax' + pIndex"
                        :travelDate="travelDate"
                      />
                       <div :key="pIndex" style="display: none">
                        <tr>
                          <td>{{ pax[pIndex].title }}</td>
                          <b-td></b-td>
                          <td>{{ pax[pIndex].lname }}</td>
                          <td>{{ pax[pIndex].fname }}</td>
                          <td>{{ pax[pIndex].age }}</td>
                          <td>{{ pax[pIndex].bdate }}</td>
                        </tr>
                      </div>
                    </template>
                  </b-tbody>
                </b-table-simple>
              </b-col>
            </b-row>
            <b-row class="my-3">
              <b-col sm="6">
                <span class="printArea">
                  <h6 v-translate>Telephone*</h6>
                  <span class="printArea" style="display: none">{{ telephone }}</span>
                </span>
                <ValidationProvider
                  name="telephone"
                  :rules="{ required: true }"
                  v-slot="vContext"
                  >
                  <b-form-group>
                    <b-form-input
                      type="text"
                      :name="'telephone'"
                      placeholder="telephone no"
                      class="form-control form-control-sm"
                      v-model="telephone"
                      size="sm"
                      :state="getValidationState(vContext)"
                      aria-describedby="telephone"
                    ></b-form-input>
                    <b-form-invalid-feedback id="telephone">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <small><em>*This phone number will be used exclusively for contacting tourists in case of emergency.</em></small>
              </b-col>
              <b-col sm="6">
                <span class="printArea">
                  <h6 v-translate>Drop Off / Hotel *</h6>
                  <span class="printArea" style="display: none">{{dropOff}}</span>
                </span>
                <ValidationProvider
                  name="drop off"
                  :rules="{ required: true }"
                  v-slot="vContext"
                  >
                  <b-form-group>
                    <b-form-input
                      type="text"
                      :name="'drop off'"
                      placeholder="drop off / hotel"
                      class="form-control form-control-sm"
                      v-model="dropOff"
                      size="sm"
                      :state="getValidationState(vContext)"
                      aria-describedby="drop off"
                    ></b-form-input>
                    <b-form-invalid-feedback id="telefon">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <small><em>*Depending on the destination, the passengers will be left at/in the hotel/resort mentioned.</em></small>
              </b-col>
              <b-col sm="12" class="mt-3">
                <div class="printArea">
                  <h6 v-translate>Agent Notes*</h6>
                  <textarea v-model="notes" class="form-control noPrint">...</textarea>
                  <div class="printArea" style="display: none">
                    <p>{{ notes }}</p>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="7">
                <b-card>
                  <ValidationProvider
                    name="terms and conditions"
                    rules="is:acceptat"
                    vid="terms"
                    v-slot="vContext"
                    slim
                  >
                    <b-form-group class="mb-0">
                      <b-form-checkbox
                        id="conditions"
                        name="conditions"
                        v-model="termsAccepted"
                        :state="getValidationState(vContext)"
                        aria-describedby="conditions-live-feedback"
                        value="acceptat"
                        unchecked-value="neacceptat"
                        >
                        <translate>I have read and agree to the</translate> <span class="text-info"  @click="openTermsAndConditions" v-translate>Terms and Conditions</span> <translate>of the marketing products.</translate>
                        </b-form-checkbox>
                      <b-form-invalid-feedback id="conditions-live-feedback" :state="getValidationState(vContext)">nu ati acceptat termenii si conditiile</b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider>

                  <!-- <ValidationProvider
                    name="conditii romania"
                    rules="is:acceptat"
                    vid="termsRomania"
                    v-slot="vContext"
                    slim
                  >
                    <b-form-group class="mb-0">
                      <b-form-checkbox
                        id="termsRomania"
                        name="termsRomania"
                        v-model="termsAcceptedRomania"
                        :state="getValidationState(vContext)"
                        aria-describedby="conditions-live-feedback"
                        value="acceptat"
                        unchecked-value="unaccepted"
                        >
                          Am citit si sunt de acord cu <span class="text-info"  @click="openTermsConditionsRomania">Conditiile Generale Transferuri din Tara</span> de comercializare a produselor.
                        </b-form-checkbox>
                      <b-form-invalid-feedback id="conditions-live-feedback" :state="getValidationState(vContext)">nu ati acceptat conditiile de transfer din tara</b-form-invalid-feedback>
                    </b-form-group>
                  </ValidationProvider> -->
                </b-card>
              </b-col>
              <b-col md="5" class="printArea">
                <b-card
                  bg-variant="light"
                  style="font-size:16px;"
                  class="text-center"
                >
                  <b-form-group class="mb-0">
                    <span><translate>PRICE</translate>: <span class="text-danger font-weight-bold">{{ price }} {{params.currency}} </span> <small>(taxe incluse)</small></span>
                  </b-form-group>
                   <div class="text-center">
                      <small v-for="(dd, ddIndex) in paymentSchedule" :key="'dd' + ddIndex">
                        {{ formatDate(dd.date) }} - <b>{{ ceil(dd.amount) || 'diferenta' }}</b>
                      </small>
                    </div>
                </b-card>
              </b-col>
            </b-row>
            <b-row  class="my-3">
              <b-col>
                <b-card
                  bg-variant="light"
                  no-body
                >
                  <b-card-body class="p-1 p-md-3">
                    <div class="d-md-flex justify-content-md-between">
                      <b-button variant="warning" size="sm" @click="back" class="mb-2 mb-md-0"><b-icon icon="chevron-left" /><translate>Back to results</translate></b-button>
                      <b-button-group size="sm">
                          <button class="btn btn-outline-primary btn-sm " @click.prevent="onPrint" v-b-tooltip.hover title="Print">
                            <b-icon icon="window" /> <translate>Print details</translate>
                          </button>
                          <button class="btn btn-outline-danger btn-sm" @click.prevent="onDownload" v-b-tooltip.hover title="PDF">
                            <b-icon icon="download" /> <translate>Pdf details</translate>
                          </button>
                          <b-button
                            v-if="false"
                            variant="primary custom-primary"
                            @click.prevent="book(true)"
                            v-b-popover.hover.top="$gettext('ATTENTION: Booking in OPTION is not guaranteed: seats are blocked on the plane, but the availability of the hotel is not guaranteed, which can enter Stop Sales')"
                            :title="$gettext('Attention!')" v-translate>Option</b-button>
                          <b-button variant="warning" type="submit" v-translate>Book</b-button>
                        </b-button-group>
                    </div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-row>
      </b-form>
    </ValidationObserver>
    <b-modal v-model="showOverlay" title="Status" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card>
        <b-aspect class="align-items-center text-center" aspect="3">
          <b-spinner label="Loading..." variant="primary"></b-spinner>
          <b-card-text>{{ overlayMessage }}</b-card-text>
        </b-aspect>
      </b-card>
    </b-modal>
    <b-modal v-model="showErrorOverlay" title="Error" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card class="justify-content-center">
        <b-aspect aspect="3" class="align-items-center">
          <b-card-title class=" font-weight-bold text-center">
            <b-icon icon="exclamation-triangle" class="text-danger mr-3"/>
            A aparut o problema
          </b-card-title>
          <hr>
          <b-card-text class="lead text-muted" v-translate> - Unfortunately the reservation could not be registered because a problem occurred.</b-card-text>
          <b-card-text class="lead text-muted" v-translate> - Generally, this happens when the price or availability of the product has changed since you searched.</b-card-text>
          <b-card-text class="lead text-muted" v-translate> The error message is: <b class="text-info">{{ errorMessage }}</b></b-card-text>
        </b-aspect>
        <hr>
        <b-button variant="warning float-right" size="sm" @click="back" v-translate>Back to results</b-button>
      </b-card>
    </b-modal>
    <b-modal v-model="termsAndConditions" title="Termeni si Conditii" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card>
        <TermsAndConditions/>
        <hr>
        <b-button variant="warning" class="float-right"  @click="closeTermsAndConditions">Accepta</b-button>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'

import model from '../services/model'
import toast from 'b2b-common/mixins/toast'
import auth from '@/app/private/shared/mixins/auth'
import validation from 'b2b-common/mixins/validation'
import PaxForm from '@/app/private/shared/components/pax_form'
import TermsAndConditions from '../../shared/components/terms_and_conditions'
import BusResult from './result.vue'
import { $gettext } from '@/config/gettext'

import { book } from 'b2b-common/services/api/bus'
import { getCustomPdf, downloadPdf, openPrintPage } from 'b2b-common/services/api/document'

const invalidFormMessage = $gettext('Invalid Form')

export default {
  mixins: [toast, auth, validation],
  props: ['params', 'result'],
  components: { BusResult, PaxForm, TermsAndConditions },
  computed: {
    price () {
      return this.result.price + this.result.tax
    }
  },
  data () {
    const travelDate = moment(this.params.date_from, 'DD-MM-YYYY')

    const pax = []

    for (let i = 0; i < this.params.adults; i++) {
      pax.push({
        title: 'Mr',
        fname: '',
        lname: '',
        age: 'adult',
        bdate: null
      })
    }
    this.params.child_ages.forEach(age => {
      pax.push({
        title: (age < 2) ? 'Inf' : 'Chd',
        fname: '',
        lname: '',
        age: age,
        bdate: null
      })
    })

    return {
      travelDate,
      noAdults: this.params.adults,
      noChildren: this.params.child_ages.length,
      notes: '',
      telephone: '',
      dropOff: '',
      pax,
      paymentSchedule: [],
      termsAccepted: 'neacceptat',
      termsAcceptedRomania: 'unaccepted',
      client: {
        clientCode: '',
        isCompany: false,
        companyName: '',
        companyNo: '',
        vatNo: '',
        bankAccount: '',
        bankName: '',
        title: 'Mr',
        firstName: '',
        lastName: '',
        idInfo: '',
        cnp: '',
        address1: '',
        address2: '',
        county: '',
        city: '',
        tel: '',
        email: ''
      },
      showErrorOverlay: false,
      showOverlay: false,
      overlayMessage: '',
      errorMessage: this.$gettext('unknown error'),
      termsAndConditions: false,
      termsConditionsRomania: false
    }
  },
  methods: {
    onPrint () {
      this.$refs.bookingForm.validate()
        .then(success => {
          if (!success) {
            this.addToast({ title: invalidFormMessage, message: this.$gettext('Please fill in all required fields!'), variant: 'danger' })
            return
          }
          const arr = document.getElementsByClassName('printArea')
          let html = ''
          arr.forEach(el => {
            html += el.innerHTML
          })
          openPrintPage({ html })
        })
    },
    onDownload () {
      this.$refs.bookingForm.validate()
        .then(success => {
          if (!success) {
            this.addToast({ title: invalidFormMessage, message: this.$gettext('Please fill in all required fields!'), variant: 'danger' })
            return
          }
          const arr = document.getElementsByClassName('printArea')
          let html = ''
          arr.forEach(el => {
            html += el.innerHTML
          })
          getCustomPdf({ html })
            .then(pdfData => {
              downloadPdf({ pdfData, fileName: this.$pgettext('file name do not use special characters, please use ASCII only', 'offer') + '.pdf', dataType: 'raw' })
            })
        })
    },
    back () {
      this.$emit('back')
    },
    openTermsAndConditions () {
      this.termsAndConditions = true
    },
    closeTermsAndConditions () {
      this.termsAndConditions = false
    },
    openTermsConditionsRomania () {
      this.termsConditionsRomania = true
    },
    closeTermsConditionsRomania () {
      this.termsConditionsRomania = false
    },
    async book (isOption = false) {
      try {
        const success = await this.$refs.bookingForm.validate()
        if (!success) {
          this.addToast({ title: invalidFormMessage, message: this.$gettext('Please fill in all required fields!'), variant: 'danger' })
          throw new Error(invalidFormMessage)
        }
        this.showOverlay = true

        const pax = [...this.pax.map(p => ({
          title: p.title,
          fname: p.fname.toUpperCase(),
          lname: p.lname.toUpperCase(),
          age: p.age,
          bdate: p.bdate
        }))]
        // now ok to create booking
        const bookParams = {
          result: this.result.index,
          notes: this.notes,
          tel: this.telephone,
          dropOff: this.dropOff,
          pax: pax
        }
        if (isOption) bookParams.status = 'option'
        const res = await book(bookParams)
        model.results = []
        this.$emit('book', res[0])
      } catch (err) {
        if (err.message !== invalidFormMessage) {
          this.errorMessage = err.message
          this.showErrorOverlay = true
        }
      } finally { this.showOverlay = false }
    },
    formatDate (d) {
      return moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY')
    }
  }
}
</script>
